export enum UserRole {
  'Stagemanager' = 'stagemanager',
  'Showcaller' = 'showcaller',
  'FloorTechnician' = 'floortechnician',
  'Troubleshooter' = 'troubleshooter',
  'Toneelmeester' = 'toneelmeester',
}
